import script from "./Copyright.vue?vue&type=script&setup=true&lang=js"
export * from "./Copyright.vue?vue&type=script&setup=true&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=4587cd84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4587cd84"]])

export default __exports__